/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AudienceMemberObjectType,
    AudienceMemberObjectTypeFromJSON,
    AudienceMemberObjectTypeFromJSONTyped,
    AudienceMemberObjectTypeToJSON,
} from './AudienceMemberObjectType';
import {
    Contact,
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
} from './Contact';
import {
    ProgramAttendee,
    ProgramAttendeeFromJSON,
    ProgramAttendeeFromJSONTyped,
    ProgramAttendeeToJSON,
} from './ProgramAttendee';
import {
    SegmentCondition,
    SegmentConditionFromJSON,
    SegmentConditionFromJSONTyped,
    SegmentConditionToJSON,
} from './SegmentCondition';

/**
 * 
 * @export
 * @interface AudienceMember
 */
export interface AudienceMember {
    /**
     * 
     * @type {string}
     * @memberof AudienceMember
     */
    id: string;
    /**
     * 
     * @type {AudienceMemberObjectType}
     * @memberof AudienceMember
     */
    object: AudienceMemberObjectType;
    /**
     * 
     * @type {string}
     * @memberof AudienceMember
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof AudienceMember
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof AudienceMember
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof AudienceMember
     */
    email: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AudienceMember
     */
    event_ids?: Array<string>;
    /**
     * 
     * @type {Contact}
     * @memberof AudienceMember
     */
    contact: Contact;
    /**
     * 
     * @type {Array<ProgramAttendee>}
     * @memberof AudienceMember
     */
    program_attendees: Array<ProgramAttendee>;
    /**
     * 
     * @type {Array<SegmentCondition>}
     * @memberof AudienceMember
     */
    conditions: Array<SegmentCondition>;
    /**
     * 
     * @type {any}
     * @memberof AudienceMember
     */
    email_data: any;
}

export function AudienceMemberFromJSON(json: any): AudienceMember {
    return AudienceMemberFromJSONTyped(json, false);
}

export function AudienceMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): AudienceMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': AudienceMemberObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'first_name': json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'email': json['email'],
        'event_ids': !exists(json, 'event_ids') ? undefined : json['event_ids'],
        'contact': ContactFromJSON(json['contact']),
        'program_attendees': ((json['program_attendees'] as Array<any>).map(ProgramAttendeeFromJSON)),
        'conditions': ((json['conditions'] as Array<any>).map(SegmentConditionFromJSON)),
        'email_data': json['email_data'],
    };
}

export function AudienceMemberToJSON(value?: AudienceMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': AudienceMemberObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'event_ids': value.event_ids,
        'contact': ContactToJSON(value.contact),
        'program_attendees': ((value.program_attendees as Array<any>).map(ProgramAttendeeToJSON)),
        'conditions': ((value.conditions as Array<any>).map(SegmentConditionToJSON)),
        'email_data': value.email_data,
    };
}

